/* eslint-disable */
import React from "react";
import { FC } from "react";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";

import { isLocalEnvironment } from "../../services/environment";
import RaindropMotionFadeUp from "../raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";

const RevealableEye = ({ setInputType }) => {
  const [isRevealing, setIsRevealing] = useState(false);

  const onClick = () => {
    setIsRevealing(!isRevealing);
  };

  useEffect(() => {
    const newInputType = isRevealing ? "text" : "password";
    setInputType(newInputType);
  }, [isRevealing]);

  let iconClass = "fas fa-eye-slash text-color-background-secondary";
  if (isRevealing) {
    iconClass = "fas fa-eye ";
  }

  return (
    <i
      onClick={onClick}
      className={`${iconClass} text-color-dark-text-secondary text-xs pr-2`}
    />
  );
};

interface RaindropInputProps {
  idInput?: string;
  type?: string;
  value?: string;
  placeholder?: string;
  example?: string;
  icon?: string;
  label?: string;
  errorMessage?: string;
  onChange?: (event: any) => void;
  maxLength?: number;
  minLength?: number;
  name?: string;
  autoComplete?: string;
  isRevealable?: boolean;
  isPassword?: boolean;
  isMinimal?: boolean;
  isLarge?: boolean;
  isFluid?: boolean;
  isEditing?: boolean;
  isShowLabel?: boolean;
  isShowingBorder?: boolean;
  isPopulatingExampleIfLocal?: boolean;
  isAnimationEnabled?: boolean;
}

const RaindropInput: FC<RaindropInputProps> = ({
  idInput = undefined,
  type = "text",
  value = null,
  placeholder = "Placeholder",
  name = undefined,
  autoComplete = "off",
  example = null,
  label = null,
  errorMessage = null,
  onChange = () => {},
  maxLength = 100,
  minLength = 0,
  isRevealable = false,
  isPassword = false,
  isLarge = false,
  isEditing = true,
  isShowingBorder = true,
  isPopulatingExampleIfLocal = true,
  isAnimationEnabled = true,
}) => {
  if (value === null) {
    value = "";
  }
  const [inputType, setInputType] = useState(type);

  let border = "";
  let borderColor =
    "border-color-border-primary dark:border-color-dark-border-primary";
  let backgroundColor =
    "bg-color-background-input dark:bg-color-dark-background-input";

  let rounded = "rounded-lg";
  let textSize = "text-sm";
  let readOnly = false;
  let paddingX = "px-3";

  let isShowLabel = label !== null;

  if (isPassword) {
    minLength = 8;
    maxLength = 100;
  }

  if (isLarge) {
    textSize = "text-2xl";
    paddingX = "px-6";
    rounded = "rounded-2xl";
  }

  if (!isEditing) {
    readOnly = true;
    paddingX = "px-0";
    border = "";
    backgroundColor = "bg-transparent";
  }

  if (!isShowingBorder) {
    border = "";
    borderColor = "";
  }

  if (errorMessage) {
    border = "border-r-4";
    borderColor = "border-color-status-bad";
  }

  if (isEditing) {
    backgroundColor =
      "bg-color-background-secondary  dark:bg-color-dark-background-input";
    borderColor =
      "border border-color-border-primary dark:border-color-dark-border-primary";
  }

  useEffect(() => {
    if (
      isPopulatingExampleIfLocal &&
      isLocalEnvironment() &&
      !value &&
      example
    ) {
      onChange({ target: { value: example } });
    }
  }, []);

  return (
    <RaindropMotionFadeUp isAnimationEnabled={isAnimationEnabled}>
      <div className="w-full">
        {isShowLabel && (
          <div
            id="input-label"
            className="text-color-dark-text-tertiary font-medium w-full text-left text-xs"
          >
            {label}
          </div>
        )}
        <div
          className={`flex flex-row w-full items-center gap-2 ${rounded} ${border} ${borderColor} ${backgroundColor} `}
        >
          <motion.input
            id={idInput}
            type={inputType}
            placeholder={placeholder}
            onChange={onChange}
            name={name}
            autoComplete={autoComplete}
            minLength={minLength}
            value={value}
            maxLength={maxLength}
            onKeyDown={() => {}}
            onKeyUp={() => {}}
            readOnly={readOnly}
            className={`py-2 rounded-lg w-full font-bold bg-transparent appearance-none focus:outline-none placeholder-color-dark-text-secondary placeholder:font-normal outline-transparent border-transparent ${textSize} dark:text-color-dark-text-secondary ${paddingX}`}
          />
          {isRevealable && (
            <RevealableEye inputType={inputType} setInputType={setInputType} />
          )}
        </div>
        <div
          id={"error-message"}
          className="text-color-status-bad font-bold text-sm w-full text-right pr-4"
        >
          {errorMessage}
        </div>
      </div>
    </RaindropMotionFadeUp>
  );
};

export default RaindropInput;
